console.log('process.env.REACT_APP_PORTAL_API_HOST', process.env.REACT_APP_PORTAL_API_HOST);
console.log('process.env.REACT_APP_API_KEY', process.env.REACT_APP_API_KEY);
console.log('process.env.REACT_APP_AUTH_DOMAIN', process.env.REACT_APP_AUTH_DOMAIN);
console.log('process.env.REACT_APP_PROJECT_ID', process.env.REACT_APP_PROJECT_ID);
console.log('process.env.REACT_APP_STORAGE_BUCKET', process.env.REACT_APP_STORAGE_BUCKET);
console.log('process.env.REACT_APP_MESSAGING_SENDER_ID', process.env.REACT_APP_MESSAGING_SENDER_ID);
console.log('process.env.REACT_APP_APP_ID', process.env.REACT_APP_APP_ID);
console.log('process.env.REACT_APP_MEASUREMENT_ID', process.env.REACT_APP_MEASUREMENT_ID);

export const PORTAL_API_HOST = process.env.REACT_APP_PORTAL_API_HOST;

export const firebaseAppConfig = {
    apiKey: process.env.REACT_APP_API_KEY,
    authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_APP_ID,
    measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

console.log('firebaseAppConfig', firebaseAppConfig);